/**
 * Функция для замена первой буквы в строке на заглавную
 * @param str исходная строка
 * @returns строка с заглавной буквы
 */
export default function capitalizeFirstLetter(string: string): string {
  return string.charAt(0).toUpperCase() + string.slice(1);
}
